import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './core/services/base.service';
import { Environment } from './core/environment/environment';
import { forkJoin } from 'rxjs';
import { AuthService } from './core/services/auth.service';
import { UserService } from './core/services/user.service';
import { StaticService } from './core/services/static.service';
import { SessionStorageService } from 'ngx-webstorage';
import { CacheConstant } from './core/cache/cache.constant';
import { AccountService } from './core/services/account.service';
import { TokenService } from './core/services/token.service';
@Injectable({
  providedIn: 'root',
})
export class AppService extends BaseService {

  constructor(
    protected http: HttpClient, private authService: AuthService,
    private userService: UserService,
    private staticService: StaticService,
    private sessionStorage : SessionStorageService,
    private accService : AccountService,
    private token: TokenService,
  ) {
    super(http);
  }

  init() {
  }

  initOnLoad(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }

  isDown(): boolean {
    const config = Environment.getInstance().appConfig.app;
    const isAppDown = config.down;

    return isAppDown;
  }

  load(): Promise<any> {
    if(this.sessionStorage.retrieve(CacheConstant.SessionStorageData.AuthToken)){
      return new Promise((resolve, reject) => {
        this.token.init();
        const user = this.userService.loadUserDetails();
        const staticData = this.staticService.loadStaticData();
        forkJoin([staticData, user]).subscribe((response: any) => {
          resolve(true);
        });
      });
    }
    else{
      this.authService.logOut();
    }

  }
}
